export const HEADER_TEMPLATE_HERO_A = 'hero_a';
export const HEADER_TEMPLATE_RESERVE = 'reserve';
export const HEADER_TEMPLATE_ECOMMERCE = 'ecommerce';
export const HEADER_TEMPLATE_ECOMMERCE_SLIDER = 'ecommerce_slider';

export const FOOTER_TEMPLATE_STANDARD = 'standard';
export const FOOTER_TEMPLATE_INSTITUCIONAL = 'institucional';

export const HEADER_TEMPLATE_CODES = [
  HEADER_TEMPLATE_HERO_A,
  HEADER_TEMPLATE_RESERVE,
  HEADER_TEMPLATE_ECOMMERCE,
  HEADER_TEMPLATE_ECOMMERCE_SLIDER,
] as const;

export type HeaderTemplateCode = (typeof HEADER_TEMPLATE_CODES)[number];

export const FOOTER_TEMPLATE_CODES = [
  FOOTER_TEMPLATE_STANDARD,
  FOOTER_TEMPLATE_INSTITUCIONAL,
] as const;

export type FooterTemplateCode = (typeof FOOTER_TEMPLATE_CODES)[number];

export const CONTACT_COLOR_DEFAULTS: Record<
  HeaderTemplateCode,
  { contactColor: string; contactTextColor: string }
> = {
  [HEADER_TEMPLATE_HERO_A]: { contactColor: '#225e8f', contactTextColor: '#1c2836' },
  [HEADER_TEMPLATE_RESERVE]: { contactColor: '#d1d4d6', contactTextColor: '#1c2836' },
  [HEADER_TEMPLATE_ECOMMERCE]: { contactColor: '#f5f5f5', contactTextColor: '#f5f5f5' },
  [HEADER_TEMPLATE_ECOMMERCE_SLIDER]: { contactColor: '#f5f5f5', contactTextColor: '#f5f5f5' },
};

export function normalizeHeaderTemplateCode(code?: string | null): HeaderTemplateCode {
  if (
    code === HEADER_TEMPLATE_RESERVE ||
    code === HEADER_TEMPLATE_ECOMMERCE ||
    code === HEADER_TEMPLATE_ECOMMERCE_SLIDER
  ) {
    return code;
  }
  return HEADER_TEMPLATE_HERO_A;
}

export function normalizeFooterTemplateCode(code?: string | null): FooterTemplateCode {
  if (code === FOOTER_TEMPLATE_INSTITUCIONAL) {
    return FOOTER_TEMPLATE_INSTITUCIONAL;
  }
  return FOOTER_TEMPLATE_STANDARD;
}

export function resolveHeroSettingsKey(templateCode: HeaderTemplateCode): string {
  return templateCode;
}

export const HERO_TITLE_FALLBACK = 'Tu próxima aventura';
